/*
 * WorkAndBuhin.vue の手入力整備削除、部品なし・整備不要状態への遷移判定を切り出した処理。
 */
import { STATUS_SELECT_WORK_BUHIN } from "@/model/StatusSelectWorkBuhin";
import { INSPECT_TYPE } from "@/model/InspectType";
import { Work } from "@/model/Work";
import { getDeletedManualBuhinKey } from "@/components/work-buhin/WorkBuhinManual";
import {
  buildNormalWorkResetState,
  buildRecommendWorkResetState,
  WorkBuhinResetState
} from "@/components/work-buhin/WorkBuhinReset";

export interface ManualWorkDeleteState {
  removedSeibi: Work[];
  activeWorkIndex: number;
  tmpDeleteWorkIndex: number;
  listManualBuhinFiltered: any[];
  listSelectedBuhin: any[];
  callbackDeleteBuhin: boolean;
  workBuhinSelected: number | null;
  isChange: boolean;
  isSocket: boolean;
}

export interface ManualWorkDeleteActionState {
  shouldDeleteManualSeibi: boolean;
  deleteManualSeibiPayload: any;
  shouldEmitCallbackDeleteManualSeibi: boolean;
  callbackDeleteManualSeibiInspectId: any;
  shouldUpdateWorkBuhinSelected: boolean;
  workBuhinSelected: number | null;
  isChange: boolean;
  isSocket: boolean;
  shouldEmitCallbackDeleteBuhin: boolean;
}

export interface ManualWorkDeleteApplyEffectState {
  activeWorkIndex: number;
  shouldChangeWorkStatus: boolean;
  shouldDeleteManualSeibi: boolean;
  deleteManualSeibiPayload: any;
  shouldEmitCallbackDeleteManualSeibi: boolean;
  callbackDeleteManualSeibiEventName: string;
  callbackDeleteManualSeibiInspectId: any;
  tmpDeleteWorkIndex: number;
  listManualBuhinFiltered: any[];
  listSelectedBuhin: any[];
  shouldMapBuhin: boolean;
  shouldUpdateWorkBuhinSelected: boolean;
  workBuhinSelected: number | null;
  isChange: boolean;
  isSocket: boolean;
  shouldEmitCallbackDeleteBuhin: boolean;
  callbackDeleteBuhinEventName: string;
}

export interface ManualWorkDeleteSuccessApplyEffectState {
  shouldEmitCallbackDeleteManualSeibi: boolean;
  callbackDeleteManualSeibiEventName: string;
  callbackDeleteManualSeibiInspectId: any;
}

export interface ManualWorkDeleteCallbackBuhinApplyEffectState {
  shouldUpdateWorkBuhinSelected: boolean;
  workBuhinSelected: number | null;
  isChange: boolean;
  isSocket: boolean;
  shouldEmitCallbackDeleteBuhin: boolean;
  callbackDeleteBuhinEventName: string;
  callbackDeleteBuhinPayload: any;
}

export interface ManualWorkDeleteCommitApplyEffectState {
  activeWorkIndex: number;
  shouldChangeWorkStatus: boolean;
  tmpDeleteWorkIndex: number;
  listManualBuhinFiltered: any[];
  listSelectedBuhin: any[];
  shouldMapBuhin: boolean;
  shouldUpdateWorkBuhinSelected: boolean;
  workBuhinSelected: number | null;
  isChange: boolean;
  isSocket: boolean;
  shouldEmitCallbackDeleteBuhin: boolean;
  callbackDeleteBuhinEventName: string;
  callbackDeleteBuhinPayload: any;
}

export interface ManualBuhinDeleteState {
  targetWork: any;
  manualBuhinList: any[];
  shouldDeleteManualBuhin: boolean;
  deleteManualBuhinId: any;
  shouldPushDeletedManualBuhinBuff: boolean;
  deletedManualBuhinKey: any;
  tmpDeletedBuhin: any;
  isChange: boolean;
  shouldEmitCallbackDeleteBuhin: boolean;
}

export interface ManualBuhinDeleteApplyEffectState {
  shouldFilterManualBuhin: boolean;
  shouldDeleteManualBuhin: boolean;
  deleteManualBuhinId: any;
  shouldPushDeletedManualBuhinBuff: boolean;
  deletedManualBuhinKey: any;
  tmpDeletedBuhin: any;
  isChange: boolean;
  targetWork: any;
  manualBuhinList: any[];
  shouldCheckWorkBuhinSelected: boolean;
  shouldCheckDisabledBtnConfirm: boolean;
  shouldEmitCallbackDeleteBuhin: boolean;
  callbackDeleteBuhinEventName: string;
}

export interface ManualBuhinDeleteApiApplyEffectState {
  shouldDeleteManualBuhin: boolean;
  deleteManualBuhinId: any;
  shouldPushDeletedManualBuhinBuff: boolean;
  deletedManualBuhinKey: any;
}

export interface ManualBuhinDeleteAfterApplyEffectState {
  tmpDeletedBuhin: any;
  isChange: boolean;
  targetWork: any;
  manualBuhinList: any[];
  shouldCheckWorkBuhinSelected: boolean;
  shouldCheckDisabledBtnConfirm: boolean;
  shouldEmitCallbackDeleteBuhin: boolean;
  callbackDeleteBuhinEventName: string;
  callbackDeleteBuhinPayload: any;
}

export interface ManualBuhinDeleteAfterCommitApplyEffectState {
  tmpDeletedBuhin: any;
  isChange: boolean;
  shouldApplyManualBuhinListToWork: boolean;
  targetWork: any;
  manualBuhinList: any[];
  shouldCheckWorkBuhinSelected: boolean;
  workBuhinSelectedCheckTarget: any;
  shouldCheckDisabledBtnConfirm: boolean;
  disabledBtnConfirmCheckTarget: any;
  shouldEmitCallbackDeleteBuhin: boolean;
  callbackDeleteBuhinEventName: string;
  callbackDeleteBuhinPayload: any;
}

export interface ManualBuhinDeleteStartApplyEffectState {
  shouldRemoveManualOrJunseiBuhin: boolean;
}

export interface DeleteResetWorkActionState {
  targetWork: any;
  shouldResetRecommendWork: boolean;
  resetState: WorkBuhinResetState;
}

export interface DeleteResetWorkApplyEffectState {
  shouldApplyWorkResetState: boolean;
  resetState: WorkBuhinResetState;
}

export interface DeleteResetWorkCommitApplyEffectState {
  shouldApplyWorkResetState: boolean;
  resetState: WorkBuhinResetState;
}

export interface ManualWorkDeleteDialogOpenActionState {
  shouldStopPropagation: boolean;
  shouldOpenDeleteDialog: boolean;
  tmpResetWorkIndex: number;
  tmpDeleteWorkIndex: number;
}

export interface ManualWorkDeleteDialogOpenApplyEffectState {
  shouldStopPropagation: boolean;
  shouldOpenDeleteDialog: boolean;
  tmpResetWorkIndex: number;
  tmpDeleteWorkIndex: number;
}

export interface ResetWorkDeleteDialogOpenActionState {
  shouldStopPropagation: boolean;
  shouldOpenDeleteDialog: boolean;
  activeWorkIndex: number;
  isManualWork: boolean;
  tmpResetWorkIndex: number;
}

export interface ResetWorkDeleteDialogOpenApplyEffectState {
  shouldStopPropagation: boolean;
  shouldOpenDeleteDialog: boolean;
  activeWorkIndex: number;
  isManualWork: boolean;
  tmpResetWorkIndex: number;
}

export interface ManualBuhinDeleteDialogOpenActionState {
  shouldStopPropagation: boolean;
  shouldOpenDeleteDialog: boolean;
  tmpResetWorkIndex: number;
  tmpDeleteWorkIndex: number;
  tmpDeletedBuhin: any;
}

export interface ManualBuhinDeleteDialogOpenApplyEffectState {
  shouldStopPropagation: boolean;
  shouldOpenDeleteDialog: boolean;
  tmpResetWorkIndex: number;
  tmpDeleteWorkIndex: number;
  tmpDeletedBuhin: any;
}

export interface ManualBuhinDeleteDialogOpenCommitApplyEffectState {
  shouldStopPropagation: boolean;
  shouldOpenDeleteDialog: boolean;
  tmpResetWorkIndex: number;
  tmpDeleteWorkIndex: number;
  tmpDeletedBuhin: any;
}

/*
 * getDeleteResetTargetWork を WorkAndBuhin.vue から分離し、
 * 削除確定フロー を親側置換や単体テストで固定するため。
 */
export function getDeleteResetTargetWork(params: {
  data: any;
  activeWorkIndex: number;
  isManualWork: boolean;
}): any {
  if (params.data.seibiList) {
    if (params.isManualWork) {
      return params.data.manualSeibiList[params.activeWorkIndex];
    }
    return params.data.seibiList[params.activeWorkIndex];
  }
  return params.data;
}

/*
 * shouldResetRecommendWorkForDelete を WorkAndBuhin.vue から分離し、
 * 削除確定フロー を親側置換や単体テストで固定するため。
 */
export function shouldResetRecommendWorkForDelete(work: any): boolean {
  return !!(work && work.sknInspectType == INSPECT_TYPE.RECOMMEND_MANUAL);
}

/*
 * buildDeleteResetWorkActionState を WorkAndBuhin.vue から分離し、
 * 通常作業/おすすめ整備削除時に適用する reset state の選択条件を固定するため。
 */
export function buildDeleteResetWorkActionState(params: {
  data: any;
  activeWorkIndex: number;
  isManualWork: boolean;
}): DeleteResetWorkActionState {
  const targetWork = getDeleteResetTargetWork(params);
  const shouldResetRecommendWork = shouldResetRecommendWorkForDelete(targetWork);
  return {
    targetWork,
    shouldResetRecommendWork,
    resetState: shouldResetRecommendWork
      ? buildRecommendWorkResetState()
      : buildNormalWorkResetState()
  };
}

/*
 * buildDeleteResetWorkApplyEffectState を WorkAndBuhin.vue から分離し、
 * 通常作業/おすすめ整備削除確定時に適用する reset state と実行条件を固定するため。
 */
export function buildDeleteResetWorkApplyEffectState(
  actionState: DeleteResetWorkActionState
): DeleteResetWorkApplyEffectState {
  return {
    shouldApplyWorkResetState: true,
    resetState: actionState.resetState
  };
}

/*
 * buildDeleteResetWorkCommitApplyEffectState を WorkAndBuhin.vue から分離し、
 * 通常作業/おすすめ整備削除確定後に component が reset state を反映する条件と対象を固定するため。
 */
export function buildDeleteResetWorkCommitApplyEffectState(
  effectState: DeleteResetWorkApplyEffectState
): DeleteResetWorkCommitApplyEffectState {
  return {
    shouldApplyWorkResetState: effectState.shouldApplyWorkResetState,
    resetState: effectState.resetState
  };
}

/*
 * buildManualWorkDeleteDialogOpenActionState を WorkAndBuhin.vue から分離し、
 * 手入力作業削除の確認 dialog を開く前に設定する一時 state を固定するため。
 */
export function buildManualWorkDeleteDialogOpenActionState(
  deleteIndex: number
): ManualWorkDeleteDialogOpenActionState {
  return {
    shouldStopPropagation: true,
    shouldOpenDeleteDialog: true,
    tmpResetWorkIndex: -1,
    tmpDeleteWorkIndex: deleteIndex
  };
}

/*
 * buildManualWorkDeleteDialogOpenApplyEffectState を WorkAndBuhin.vue から分離し、
 * 手入力作業削除 dialog open 前に component が実行するイベント停止と一時 state 反映条件を固定するため。
 */
export function buildManualWorkDeleteDialogOpenApplyEffectState(
  actionState: ManualWorkDeleteDialogOpenActionState
): ManualWorkDeleteDialogOpenApplyEffectState {
  return {
    shouldStopPropagation: actionState.shouldStopPropagation,
    shouldOpenDeleteDialog: actionState.shouldOpenDeleteDialog,
    tmpResetWorkIndex: actionState.tmpResetWorkIndex,
    tmpDeleteWorkIndex: actionState.tmpDeleteWorkIndex
  };
}

/*
 * buildResetWorkDeleteDialogOpenActionState を WorkAndBuhin.vue から分離し、
 * 通常作業/おすすめ整備削除の確認 dialog を開く前に選択作業 state を固定するため。
 */
export function buildResetWorkDeleteDialogOpenActionState(
  workIndex: number
): ResetWorkDeleteDialogOpenActionState {
  return {
    shouldStopPropagation: true,
    shouldOpenDeleteDialog: true,
    activeWorkIndex: workIndex,
    isManualWork: false,
    tmpResetWorkIndex: workIndex
  };
}

/*
 * buildResetWorkDeleteDialogOpenApplyEffectState を WorkAndBuhin.vue から分離し、
 * 通常作業/おすすめ整備削除 dialog open 前に component が反映する active 作業と一時 state を固定するため。
 */
export function buildResetWorkDeleteDialogOpenApplyEffectState(
  actionState: ResetWorkDeleteDialogOpenActionState
): ResetWorkDeleteDialogOpenApplyEffectState {
  return {
    shouldStopPropagation: actionState.shouldStopPropagation,
    shouldOpenDeleteDialog: actionState.shouldOpenDeleteDialog,
    activeWorkIndex: actionState.activeWorkIndex,
    isManualWork: actionState.isManualWork,
    tmpResetWorkIndex: actionState.tmpResetWorkIndex
  };
}

/*
 * buildManualBuhinDeleteDialogOpenActionState を WorkAndBuhin.vue から分離し、
 * 手入力部品/純正部品削除時の disabled 分岐と削除対象の一時 state を固定するため。
 */
export function buildManualBuhinDeleteDialogOpenActionState(params: {
  disabledBtnNoBuhin: boolean;
  deletedBuhin: any;
}): ManualBuhinDeleteDialogOpenActionState {
  if (params.disabledBtnNoBuhin) {
    return {
      shouldStopPropagation: true,
      shouldOpenDeleteDialog: false,
      tmpResetWorkIndex: -1,
      tmpDeleteWorkIndex: -1,
      tmpDeletedBuhin: null
    };
  }
  return {
    shouldStopPropagation: true,
    shouldOpenDeleteDialog: true,
    tmpResetWorkIndex: -1,
    tmpDeleteWorkIndex: -1,
    tmpDeletedBuhin: params.deletedBuhin
  };
}

/*
 * buildManualBuhinDeleteDialogOpenApplyEffectState を WorkAndBuhin.vue から分離し、
 * 手入力部品/純正部品削除 dialog open 前に component が実行するイベント停止と削除対象一時 state を固定するため。
 */
export function buildManualBuhinDeleteDialogOpenApplyEffectState(
  actionState: ManualBuhinDeleteDialogOpenActionState
): ManualBuhinDeleteDialogOpenApplyEffectState {
  return {
    shouldStopPropagation: actionState.shouldStopPropagation,
    shouldOpenDeleteDialog: actionState.shouldOpenDeleteDialog,
    tmpResetWorkIndex: actionState.tmpResetWorkIndex,
    tmpDeleteWorkIndex: actionState.tmpDeleteWorkIndex,
    tmpDeletedBuhin: actionState.tmpDeletedBuhin
  };
}

/*
 * buildManualBuhinDeleteDialogOpenCommitApplyEffectState を WorkAndBuhin.vue から分離し、
 * 手入力部品/純正部品削除 dialog open 前に component が反映するイベント停止、一時 state、dialog 表示条件を固定するため。
 */
export function buildManualBuhinDeleteDialogOpenCommitApplyEffectState(
  effectState: ManualBuhinDeleteDialogOpenApplyEffectState
): ManualBuhinDeleteDialogOpenCommitApplyEffectState {
  return {
    shouldStopPropagation: effectState.shouldStopPropagation,
    shouldOpenDeleteDialog: effectState.shouldOpenDeleteDialog,
    tmpResetWorkIndex: effectState.tmpResetWorkIndex,
    tmpDeleteWorkIndex: effectState.tmpDeleteWorkIndex,
    tmpDeletedBuhin: effectState.tmpDeletedBuhin
  };
}

/*
 * buildDeleteManualSeibiPayload を WorkAndBuhin.vue から分離し、
 * 削除確定フロー を親側置換や単体テストで固定するため。
 */
export function buildDeleteManualSeibiPayload(
  seibi: Work | null | undefined,
  uketsukeExtendsId: number
): any | null {
  if (!seibi || seibi.seibiId == null) {
    return null;
  }
  return {
    sknUketsukeManualSeibiId: seibi.seibiId,
    uketsukeExtendsId
  };
}

/*
 * deleteManualWorkFromList を WorkAndBuhin.vue から分離し、
 * 削除確定フロー を親側置換や単体テストで固定するため。
 */
export function deleteManualWorkFromList(params: {
  manualSeibiList: Work[];
  deleteIndex: number;
  activeWorkIndex: number;
  isManualWork: boolean;
  seibiList: Work[];
  isDialog: boolean;
}): ManualWorkDeleteState {
  const removedSeibi = params.manualSeibiList.splice(params.deleteIndex, 1);
  let activeWorkIndex = params.activeWorkIndex;
  if (params.activeWorkIndex == params.deleteIndex && params.isManualWork) {
    activeWorkIndex = -1;
  }

  let callbackDeleteBuhin = false;
  let workBuhinSelected: number | null = null;
  let isChange = false;
  let isSocket = false;
  const isSeibiAllNobuhin = params.seibiList.every(
    (work: any) => work.buhinSelected == 0
  );

  if (params.seibiList.length == 0 && params.manualSeibiList.length == 0) {
    callbackDeleteBuhin = true;
    isChange = true;
    isSocket = true;
    if (params.isDialog) {
      workBuhinSelected = STATUS_SELECT_WORK_BUHIN.NoNeed;
    }
  } else if (isSeibiAllNobuhin && params.manualSeibiList.length == 0) {
    callbackDeleteBuhin = true;
    isChange = true;
    isSocket = true;
    workBuhinSelected = STATUS_SELECT_WORK_BUHIN.Initial;
  }

  return {
    removedSeibi,
    activeWorkIndex,
    tmpDeleteWorkIndex: -1,
    listManualBuhinFiltered: [],
    listSelectedBuhin: [],
    callbackDeleteBuhin,
    workBuhinSelected,
    isChange,
    isSocket
  };
}

/*
 * buildManualWorkDeleteActionState を WorkAndBuhin.vue から分離し、
 * 手入力作業削除後の API/emit/state 反映条件を固定するため。
 */
export function buildManualWorkDeleteActionState(params: {
  deleteState: ManualWorkDeleteState;
  uketsukeExtendsId: number;
  sknUketsukeInspectId: any;
}): ManualWorkDeleteActionState {
  const deleteManualSeibiPayload = buildDeleteManualSeibiPayload(
    params.deleteState.removedSeibi[0],
    params.uketsukeExtendsId
  );
  const shouldDeleteManualSeibi = !!deleteManualSeibiPayload;
  return {
    shouldDeleteManualSeibi,
    deleteManualSeibiPayload,
    shouldEmitCallbackDeleteManualSeibi: shouldDeleteManualSeibi,
    callbackDeleteManualSeibiInspectId: params.sknUketsukeInspectId,
    shouldUpdateWorkBuhinSelected:
      params.deleteState.workBuhinSelected != null,
    workBuhinSelected: params.deleteState.workBuhinSelected,
    isChange: params.deleteState.isChange,
    isSocket: params.deleteState.isSocket,
    shouldEmitCallbackDeleteBuhin: params.deleteState.callbackDeleteBuhin
  };
}

/*
 * buildManualWorkDeleteApplyEffectState を WorkAndBuhin.vue から分離し、
 * 手入力作業削除後の API、画面 state、map、callback emit の副作用条件を固定するため。
 */
export function buildManualWorkDeleteApplyEffectState(params: {
  deleteState: ManualWorkDeleteState;
  actionState: ManualWorkDeleteActionState;
}): ManualWorkDeleteApplyEffectState {
  return {
    activeWorkIndex: params.deleteState.activeWorkIndex,
    shouldChangeWorkStatus: true,
    shouldDeleteManualSeibi: params.actionState.shouldDeleteManualSeibi,
    deleteManualSeibiPayload: params.actionState.deleteManualSeibiPayload,
    shouldEmitCallbackDeleteManualSeibi:
      params.actionState.shouldEmitCallbackDeleteManualSeibi,
    callbackDeleteManualSeibiEventName: "onCallbackDeleteManualSeibi",
    callbackDeleteManualSeibiInspectId:
      params.actionState.callbackDeleteManualSeibiInspectId,
    tmpDeleteWorkIndex: params.deleteState.tmpDeleteWorkIndex,
    listManualBuhinFiltered: params.deleteState.listManualBuhinFiltered,
    listSelectedBuhin: params.deleteState.listSelectedBuhin,
    shouldMapBuhin: true,
    shouldUpdateWorkBuhinSelected: params.actionState.shouldUpdateWorkBuhinSelected,
    workBuhinSelected: params.actionState.workBuhinSelected,
    isChange: params.actionState.isChange,
    isSocket: params.actionState.isSocket,
    shouldEmitCallbackDeleteBuhin: params.actionState.shouldEmitCallbackDeleteBuhin,
    callbackDeleteBuhinEventName: "callbackDeleteBuhin"
  };
}

/*
 * buildManualWorkDeleteSuccessApplyEffectState を WorkAndBuhin.vue から分離し、
 * 手入力作業削除 API 成功後の callback emit 条件、event 名、inspect id を固定するため。
 */
export function buildManualWorkDeleteSuccessApplyEffectState(
  effectState: ManualWorkDeleteApplyEffectState
): ManualWorkDeleteSuccessApplyEffectState {
  return {
    shouldEmitCallbackDeleteManualSeibi:
      effectState.shouldEmitCallbackDeleteManualSeibi,
    callbackDeleteManualSeibiEventName:
      effectState.callbackDeleteManualSeibiEventName,
    callbackDeleteManualSeibiInspectId:
      effectState.callbackDeleteManualSeibiInspectId
  };
}

/*
 * buildManualWorkDeleteCallbackBuhinApplyEffectState を WorkAndBuhin.vue から分離し、
 * 手入力作業削除後の callbackDeleteBuhin emit 前に反映する state と payload を固定するため。
 */
export function buildManualWorkDeleteCallbackBuhinApplyEffectState(params: {
  effectState: ManualWorkDeleteApplyEffectState;
  data: any;
}): ManualWorkDeleteCallbackBuhinApplyEffectState {
  return {
    shouldUpdateWorkBuhinSelected:
      params.effectState.shouldUpdateWorkBuhinSelected,
    workBuhinSelected: params.effectState.workBuhinSelected,
    isChange: params.effectState.isChange,
    isSocket: params.effectState.isSocket,
    shouldEmitCallbackDeleteBuhin:
      params.effectState.shouldEmitCallbackDeleteBuhin,
    callbackDeleteBuhinEventName: params.effectState.callbackDeleteBuhinEventName,
    callbackDeleteBuhinPayload: { data: params.data }
  };
}

/*
 * buildManualWorkDeleteCommitApplyEffectState を WorkAndBuhin.vue から分離し、
 * 手入力作業削除後に画面へ即時反映する state、map、callbackDeleteBuhin の適用対象を固定するため。
 */
export function buildManualWorkDeleteCommitApplyEffectState(params: {
  effectState: ManualWorkDeleteApplyEffectState;
  callbackBuhinEffectState: ManualWorkDeleteCallbackBuhinApplyEffectState;
}): ManualWorkDeleteCommitApplyEffectState {
  return {
    activeWorkIndex: params.effectState.activeWorkIndex,
    shouldChangeWorkStatus: params.effectState.shouldChangeWorkStatus,
    tmpDeleteWorkIndex: params.effectState.tmpDeleteWorkIndex,
    listManualBuhinFiltered: params.effectState.listManualBuhinFiltered,
    listSelectedBuhin: params.effectState.listSelectedBuhin,
    shouldMapBuhin: params.effectState.shouldMapBuhin,
    shouldUpdateWorkBuhinSelected:
      params.callbackBuhinEffectState.shouldUpdateWorkBuhinSelected,
    workBuhinSelected: params.callbackBuhinEffectState.workBuhinSelected,
    isChange: params.callbackBuhinEffectState.isChange,
    isSocket: params.callbackBuhinEffectState.isSocket,
    shouldEmitCallbackDeleteBuhin:
      params.callbackBuhinEffectState.shouldEmitCallbackDeleteBuhin,
    callbackDeleteBuhinEventName:
      params.callbackBuhinEffectState.callbackDeleteBuhinEventName,
    callbackDeleteBuhinPayload:
      params.callbackBuhinEffectState.callbackDeleteBuhinPayload
  };
}

/*
 * getTargetWorkForManualBuhinDelete を WorkAndBuhin.vue から分離し、
 * 削除確定フロー を親側置換や単体テストで固定するため。
 */
export function getTargetWorkForManualBuhinDelete(params: {
  data: any;
  activeWorkIndex: number;
  isManualWork: boolean;
}): any {
  if (params.activeWorkIndex > -1) {
    if (params.isManualWork) {
      const manualWorkList = params.data && params.data.manualSeibiList;
      return Array.isArray(manualWorkList)
        ? manualWorkList[params.activeWorkIndex]
        : params.data;
    }
    const normalWorkList = params.data && params.data.seibiList;
    return Array.isArray(normalWorkList)
      ? normalWorkList[params.activeWorkIndex]
      : params.data;
  }
  return params.data;
}

/*
 * buildManualBuhinDeleteState を WorkAndBuhin.vue から分離し、
 * 手入力部品/純正部品削除後の API 実行条件と state 反映順序を固定するため。
 */
export function buildManualBuhinDeleteState(params: {
  data: any;
  activeWorkIndex: number;
  isManualWork: boolean;
  listManualBuhin: any[];
  deletedBuhin: any;
  isDialog: boolean;
}): ManualBuhinDeleteState {
  const targetWork = getTargetWorkForManualBuhinDelete({
    data: params.data,
    activeWorkIndex: params.activeWorkIndex,
    isManualWork: params.isManualWork
  });
  const shouldDeleteManualBuhin = !!(
    params.deletedBuhin && params.deletedBuhin.id
  );
  return {
    targetWork,
    manualBuhinList: params.listManualBuhin,
    shouldDeleteManualBuhin,
    deleteManualBuhinId: shouldDeleteManualBuhin
      ? params.deletedBuhin.id
      : null,
    shouldPushDeletedManualBuhinBuff:
      shouldDeleteManualBuhin && params.isDialog,
    deletedManualBuhinKey: shouldDeleteManualBuhin && params.isDialog
      ? getDeletedManualBuhinKey(params.deletedBuhin)
      : null,
    tmpDeletedBuhin: null,
    isChange: true,
    shouldEmitCallbackDeleteBuhin: true
  };
}

/*
 * buildManualBuhinDeleteStartApplyEffectState を WorkAndBuhin.vue から分離し、
 * 手入力部品/純正部品削除確定直後に対象部品を list から除去する条件を固定するため。
 */
export function buildManualBuhinDeleteStartApplyEffectState():
  ManualBuhinDeleteStartApplyEffectState {
  return {
    shouldRemoveManualOrJunseiBuhin: true
  };
}

/*
 * buildManualBuhinDeleteApplyEffectState を WorkAndBuhin.vue から分離し、
 * 手入力部品/純正部品削除後の API、削除バッファ、作業 list、callback emit の副作用条件を固定するため。
 */
export function buildManualBuhinDeleteApplyEffectState(
  deleteState: ManualBuhinDeleteState
): ManualBuhinDeleteApplyEffectState {
  return {
    shouldFilterManualBuhin: true,
    shouldDeleteManualBuhin: deleteState.shouldDeleteManualBuhin,
    deleteManualBuhinId: deleteState.deleteManualBuhinId,
    shouldPushDeletedManualBuhinBuff: deleteState.shouldPushDeletedManualBuhinBuff,
    deletedManualBuhinKey: deleteState.deletedManualBuhinKey,
    tmpDeletedBuhin: deleteState.tmpDeletedBuhin,
    isChange: deleteState.isChange,
    targetWork: deleteState.targetWork,
    manualBuhinList: deleteState.manualBuhinList,
    shouldCheckWorkBuhinSelected: true,
    shouldCheckDisabledBtnConfirm: true,
    shouldEmitCallbackDeleteBuhin: deleteState.shouldEmitCallbackDeleteBuhin,
    callbackDeleteBuhinEventName: "callbackDeleteBuhin"
  };
}

/*
 * buildManualBuhinDeleteApiApplyEffectState を WorkAndBuhin.vue から分離し、
 * 手入力部品/純正部品削除時の API 実行条件と削除済み buffer 追加条件を固定するため。
 */
export function buildManualBuhinDeleteApiApplyEffectState(
  effectState: ManualBuhinDeleteApplyEffectState
): ManualBuhinDeleteApiApplyEffectState {
  return {
    shouldDeleteManualBuhin: effectState.shouldDeleteManualBuhin,
    deleteManualBuhinId: effectState.deleteManualBuhinId,
    shouldPushDeletedManualBuhinBuff: effectState.shouldPushDeletedManualBuhinBuff,
    deletedManualBuhinKey: effectState.deletedManualBuhinKey
  };
}

/*
 * buildManualBuhinDeleteAfterApplyEffectState を WorkAndBuhin.vue から分離し、
 * 手入力部品/純正部品削除後の local state、対象作業、再判定、callback payload を固定するため。
 */
export function buildManualBuhinDeleteAfterApplyEffectState(params: {
  effectState: ManualBuhinDeleteApplyEffectState;
  data: any;
}): ManualBuhinDeleteAfterApplyEffectState {
  return {
    tmpDeletedBuhin: params.effectState.tmpDeletedBuhin,
    isChange: params.effectState.isChange,
    targetWork: params.effectState.targetWork,
    manualBuhinList: params.effectState.manualBuhinList,
    shouldCheckWorkBuhinSelected:
      params.effectState.shouldCheckWorkBuhinSelected,
    shouldCheckDisabledBtnConfirm:
      params.effectState.shouldCheckDisabledBtnConfirm,
    shouldEmitCallbackDeleteBuhin:
      params.effectState.shouldEmitCallbackDeleteBuhin,
    callbackDeleteBuhinEventName: params.effectState.callbackDeleteBuhinEventName,
    callbackDeleteBuhinPayload: { data: params.data }
  };
}

/*
 * buildManualBuhinDeleteAfterCommitApplyEffectState を WorkAndBuhin.vue から分離し、
 * 手入力部品/純正部品削除後に local state、対象 work、再判定、callback emit を反映する順序と対象を固定するため。
 */
export function buildManualBuhinDeleteAfterCommitApplyEffectState(
  effectState: ManualBuhinDeleteAfterApplyEffectState
): ManualBuhinDeleteAfterCommitApplyEffectState {
  return {
    tmpDeletedBuhin: effectState.tmpDeletedBuhin,
    isChange: effectState.isChange,
    shouldApplyManualBuhinListToWork: effectState.targetWork != null,
    targetWork: effectState.targetWork,
    manualBuhinList: effectState.manualBuhinList,
    shouldCheckWorkBuhinSelected: effectState.shouldCheckWorkBuhinSelected,
    workBuhinSelectedCheckTarget: effectState.targetWork,
    shouldCheckDisabledBtnConfirm: effectState.shouldCheckDisabledBtnConfirm,
    disabledBtnConfirmCheckTarget: effectState.targetWork,
    shouldEmitCallbackDeleteBuhin: effectState.shouldEmitCallbackDeleteBuhin,
    callbackDeleteBuhinEventName: effectState.callbackDeleteBuhinEventName,
    callbackDeleteBuhinPayload: effectState.callbackDeleteBuhinPayload
  };
}
